/* eslint-disable @nx/enforce-module-boundaries */
import { ExpandIcon } from '@mybridge/icons/Expand';
import { ZoomOutIcon } from '@mybridge/icons/ZoomOutIcon';
import { ZoomInIcon } from '@mybridge/icons/ZoomInIcon';
import { SmileySadIcon } from '@mybridge/icons';

import { Card, CloseButton, IconButton, Image, Scrollable,Text } from '@mybridge/ui';
import { MyBridgeLogoMain } from '@mybridge/icons/MyBridgeLogo';
import { Heading } from '@mybridge/ui/heading';
import { Box, HStack, Stack, VStack } from '@mybridge/ui/layout';
import Link from 'next/link';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Spinner } from '@mybridge/ui/spinner';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';
import { ModalMediaDisplay } from 'v4/components/post/modal-media-display';
import { getPostFunc } from 'v4/lib/api/post';
import { getUserFullName } from 'v4/lib/commons';
import { DashboardPostBox } from '../feed/post-box';
import { isMobile } from 'react-device-detect';
import { BackArrow } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const DashboardPostContainer = ({
  postId,
  onClose,
  setHasMedia,
  initialPostData,
  openMedia,
  ...props
}) => {
  // const [loading, setLoading] = useState(true);
  const [showMediaPost, setShowMediaPost] = useState(false);
  const currentLanguage = useSelector((state) => state.translation.language) || 'en';
  const { t } = useTranslator();
  const name = currentLanguage === 'en' ? "'s post" : t('otherModules.post')
  const [expanded, setExpanded] = useState(false);
  const { deletedPosts } = useSelector((state) => state.posts ?? {});
  const [zoom, setZoom] = useState(1); // Zoom state
  const maxZoom = 3; // Maximum zoom level
  const minZoom = 1; // Minimum zoom level

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 2000);
  // }, []);
 
  // query for fetching single post
  const { refetch: fetchPost, data, isLoading, isFetching } = useQuery(
    ['getPostDetail', postId],
    getPostFunc,
    {
      refetchOnWindowFocus: false,
      enabled: !!postId,
      initialData: initialPostData?.id === postId ? initialPostData : undefined,
    }
  );
  
  const postBoxContext = usePostBoxContext({
    post: data,
    initialFetchComments: true,
  });

  const { refetch, refetchComments, post, hasMedia = true, setCurrentMediaToShow } = postBoxContext ?? {};
  const { query } = useRouter();

  // If navigated here with ?openMedia=... or openMedia prop, pre-set the media to show
  useEffect(() => {
    const mediaToOpen = openMedia || (query?.openMedia ? decodeURIComponent(query.openMedia) : null);
    if (mediaToOpen && setCurrentMediaToShow && post?.id) {
      setCurrentMediaToShow(mediaToOpen);
    }
  }, [query?.openMedia, openMedia, post?.id, setCurrentMediaToShow]);

  // const loading = isLoading || isFetching || !data;
  const loading = !data && (isLoading || isFetching);

  useEffect(() => {
    setHasMedia?.(hasMedia);
  }, [hasMedia]);

  useEffect(() => {
    if (deletedPosts?.includes?.(post?.id)) {
      onClose?.();
    }
  }, [deletedPosts, post, onClose]);

  useEffect(() => {
    if (post?.ignored) {
      onClose?.();
    }
  }, [post?.ignored, onClose]);

  useEffect(() => {
    setTimeout(() => {
      // refetch?.();
      refetchComments?.();
    }, 0);
  }, []);

  useEffect(() => {
    const getLocalStorage = localStorage.getItem('commentCLicked');
    setShowMediaPost(getLocalStorage);
    // fetchPost?.();
  }, []);

  const handleOnClose = (e) => {
    localStorage.removeItem('commentCLicked');
    onClose?.();
  };

  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.1, maxZoom)); // Max zoom level is 3
  };

  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, minZoom)); // Min zoom level is 1
  };


  const isError = data && (data.status_code >= 400 || !data?.id);

  if (isError) {
    return (
      <>
        <ModalHeader borderBottom="1px solid #ddd" px={2}>
          <HStack>
            {isMobile && <BackArrow onClick={handleOnClose} />}
            <Heading
              size={['sm', 'md']}
              flex={1}
              textAlign="center"
              color="#3D5A80"
              fontWeight="400"
              zIndex={2}
            >
              {"Post Not Found"}
            </Heading>
            {!isMobile && <CloseButton onClick={handleOnClose} />}
          </HStack>
        </ModalHeader>
        <ModalBody p={6} className="postModalContainer">
          <VStack py={12} spacing={4} justifyContent="center" alignItems="center" w="100%">
            <Box color="gray.400" bg="gray.50" p={6} borderRadius="full">
              <SmileySadIcon width="48px" height="48px" />
            </Box>
            <VStack spacing={1} textAlign="center">
              <Text fontSize="lg" fontWeight="600" color="gray.700">
                {"This post is unavailable"}
              </Text>
              <Text fontSize="sm" color="gray.500" maxW="320px">
                {"It may have been deleted by the user or the link might be broken."}
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
      </>
    );
  }
  

  if (post?.ignored) {
    return null;
  }

  return (
    <PostBoxContext.Provider value={postBoxContext}>
      {!hasMedia ? (
        <ModalHeader borderBottom="1px solid #ddd" px={2}>
          <HStack>
            {isMobile && <BackArrow onClick={handleOnClose} />}
            <Heading
              size={['sm', 'md']}
              flex={1}
              textAlign="center"
              color="#3D5A80"
              fontWeight="400"
              zIndex={2}
            >
           {getUserFullName(post?.author) && `${getUserFullName(post?.author)+name}`}
   
            </Heading>
            {!isMobile && <CloseButton onClick={handleOnClose} />}
          </HStack>
        </ModalHeader>
      ) : null}
      <ModalBody   style={{
              scrollbarGutter: 'stable', // Adds space between content and scrollbar
            }} p={0} className="postModalContainer">
        {loading ? (
          <HStack
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            alignItems="center"
            justifyContent="center"
            zIndex="5"
            bg="white"
          >
            <Spinner size="sm" color="black" />
            <VStack>
            <Text>{t('otherModules.postLoading') || "Post is loading"}..</Text>
            </VStack>
          </HStack>
        ) : (
          ""
        )}
        <HStack
          flexDirection={['column', 'column', 'row']}
          /* alignItems={!isMobile?"stretch":"center"} */
          alignItems="stretch"
          spacing={0}
          minH={hasMedia ? '100vh' : ''}
          // pos="relative"
          pos={hasMedia ? "fixed" : "relative"}
          inset={hasMedia ? "0" : ''}

        >
          {hasMedia && !post?.removed && !post?.ignored ? (
            <>
              <HStack
                pos="fixed"
                top="0"
                left="0"
                right="0"
                zIndex="2"
                px={2}
                maxW={['100%', '100%', expanded ? '100%' : '70%']}
              >
                <HStack bg="transparent" color="white">
                  {/* {!isMobile && <CloseButton onClick={handleOnClose} />} */}
                  <CloseButton onClick={handleOnClose} />
                </HStack>

                <Box flex={1} p={2}>
                  <Link href="/" as="/">
                    <MyBridgeLogoMain width={isMobile ? '30px' : '44px'} />
                  </Link>
                </Box>

                <HStack
                  borderRadius="full"
                  bg="transparent"
                  justifyContent="end"
                >
                  <IconButton
                   opacity= {zoom >= maxZoom ? 0.5 : 1}
                   cursor= {zoom >= maxZoom ? 'not-allowed' : 'pointer'}
                    onClick={handleZoomIn}
                    variant="ghost"
                    color="#5B5B5B"
                    _hover={{ bg: 'transparent' }}
                  >
                    <ZoomInIcon width="20" height="20" />
                  </IconButton>
                  <IconButton
                   opacity= {zoom <= minZoom ? 0.5 : 1}
                   cursor= {zoom <= minZoom ? 'not-allowed' : 'pointer'}
                    onClick={handleZoomOut}
                    variant="ghost"
                    color="#5B5B5B"
                    _hover={{ bg: 'transparent' }}
                  >
                    <ZoomOutIcon width="20" height="20" />
                  </IconButton>
                  <IconButton
                    onClick={(e) => {
                      setExpanded(!expanded);
                    }}
                    variant="ghost"
                    color="#5B5B5B"
                    _hover={{ bg: 'transparent' }}
                  >
                    <ExpandIcon width="20" height="20" />
                  </IconButton>
                </HStack>
              </HStack>

              {/* Left View */}
              <HStack
                // flex={"1 1 80%"}
                /* flex={1} */
                flex={['none', 'none', 1]}
                h={expanded ? '100vh' : ['50vh', '50vh', '100vh']}
                bg="black"
                maxH={expanded ? '100vh' : ['50vh', '50vh', '100vh']}
                w="100%"
                maxW={['100%', '100%', expanded ? '100%' : '70%']}
                /* position={!isMobile ? "sticky" : ""} */
                position={['static', 'static', 'sticky']}
                top={0}
                justifyContent="center"
                spacing={0}
                overflowY="hidden"
                _hover={{ overflowY: 'auto' }}
              >
                <ModalMediaDisplay zoom={zoom} fullScreen={expanded} />
              </HStack>
            </>
          ) : (
            ''
          )}
          {post?.id && !expanded && !post?.ignored ? (
            <Box
              /* flex={['auto', 'auto', 1]} */
              flex={['1 1 50vh', '1 1 50vh', 1]}
              h={hasMedia ? ['50vh', '50vh', '100%'] : 'auto'}
              w="100%"
              /* maxW={expanded ? 0 : hasMedia&&!isMobile ? '30%' : '100%'} */
              maxW={['100%', '100%', expanded ? 0 : hasMedia ? '30%' : '100%']}
              maxH="100%"
              overflowX={!hasMedia ? 'hidden' : ''} //when post is open in modal it hide scrollbar at the bottom.
              // overflow="hidden"
              overflowY={hasMedia?'auto':'hidden'}
            >
              <DashboardPostBox
                post={post}
                isInFrame={true}
                showMedia={post?.type === 3 || showMediaPost ? true : false}
                showComments={true}
                openedInPopup={true}
                context={postBoxContext}
              />
            </Box>
          ) : null}
        </HStack>
      </ModalBody>
    </PostBoxContext.Provider>
  );
};